import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputItem from './input-item';

export const FreightPriceForm = ({
  unitList = [],
  arrContType,
  name,
  requiredTitle = 'Vui lòng nhập thông tin',
  value,
  label = '',
  onChange,
  error = false,
  helperText = '',
  isAddRow = true,
  closeCheckedItem,
  disabledField = false,
  keyArray = 'arrCont', // array cont main
  keyNameOfArray = 'contTypeCode', // name of array cont
  widthContainerLeft = '15%',
  widthContainerBody = '45%',
  widthContainerRight = '35%',
}) => {
  const initialValue = {
    remark: '',
    unitCode: '',
    [keyArray]: arrContType?.map((item) => ({ [keyNameOfArray]: item, price: 0, commission: 0 })),
  };
  const [values, setValues] = React.useState([initialValue]);
  const initRef = React.useRef(true);

  React.useEffect(() => {
    if (values?.length > 0 && arrContType?.length > 0) {
      const datas = values?.map((item) => {
        const data = arrContType?.map((contType) => {
          const cont = item[keyArray]?.find((el) => el[keyNameOfArray] === contType);
          if (cont) {
            return cont;
          }
          return { [keyNameOfArray]: contType, price: 0, commission: 0 };
        });
        return { ...item, [keyArray]: data };
      });
      setValues(datas);
    }
  }, [arrContType?.length]);

  const onAdd = () => {
    setValues((prev) => {
      let tmp = [...prev];
      tmp.push({
        remark: '',
        unitCode: '',
        [keyArray]: arrContType?.map((item) => ({
          [keyNameOfArray]: item,
          price: 0,
          commission: 0,
        })),
      });
      return tmp;
    });
  };
  const onDelete = (index) => {
    if (values && values.length === 1) {
      setValues([initialValue]);
      closeCheckedItem && closeCheckedItem();
    } else {
      setValues((prev) => {
        prev.splice(index, 1);
        return [...prev];
      });
    }
  };

  React.useEffect(() => {
    if (initRef.current && value?.length) {
      setValues(value);
      initRef.current = false;
    }
  }, [value]);
  React.useEffect(() => {
    onChange &&
      onChange({
        persist: () => {},
        target: {
          type: 'change',
          name,
          value: values,
        },
      });
  }, [values]);
  const renderItems = (item, index) => {
    return (
      <InputItem
        key={'price board-' + index}
        unitList={unitList}
        item={item}
        index={index}
        onAdd={onAdd}
        onDelete={onDelete}
        values={values}
        setValues={setValues}
        error={error}
        isAddRow={isAddRow}
        disabledField={disabledField}
        keyArray={keyArray}
        keyNameOfArray={keyNameOfArray}
        widthContainerLeft={widthContainerLeft}
        widthContainerBody={widthContainerBody}
        widthContainerRight={widthContainerRight}
      />
    );
  };
  return (
    <FormGroup margin="dense">
      <FormLabel>{label}</FormLabel>
      {values.map((item, index) => renderItems(item, index))}
      <FormHelperText error={error}>{helperText && requiredTitle}</FormHelperText>
    </FormGroup>
  );
};
